// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.donor-lookup[data-v-67f030ad] {\n\tmax-width: 500px;\n}\n.household-address[data-v-67f030ad] {\n\tmargin-top: 10px;\n\tdisplay: block;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
